export const isAcceptableFileType = (fileName) => {
    if (!fileName) return false;
    let ext = fileName.match(/\.([^\.]+)$/);
    if (!ext || ext.length < 2) return false;
    switch (ext[1].toLowerCase()) {
    case 'jpg':
    case 'jpeg':
    case 'pdf':
    case 'png':
    case 'gif':
    case 'tif':
    case 'tiff':
    case 'csv':
    case 'xls':
    case 'xlsx':
        return true;
    default:
        return false;
    }
}

export const objectToFormData = (obj, form, namespace, includeUndefinedValues=false) => {
    var fd = form || new FormData();
    var formKey;
    
    for(var property in obj) {
        if(obj.hasOwnProperty(property)) {
            if(namespace) {
                formKey = namespace + '[' + property + ']';
            } else {
                formKey = property;
            }
            // if the property is an object, but not a File,
            // use recursivity.
            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, property);
            } else if (typeof obj[property] == "undefined" && !includeUndefinedValues) {
                // skip undefined values

            } else {
                // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }
        }
    }
    return fd;
};